import app from 'flarum/forum/app';
import InsertBetweenPostsAds from './InsertBetweenPostsAds';
import InsertBetweenDiscussionsAds from './InsertBetweenDiscussionsAds';
import InsertDiscussionPageHeaderAd from './InsertDiscussionPageHeaderAd';
import InsertDiscussionSidebarAd from './InsertDiscussionSidebarAd';
import InsertFooterAd from './InsertFooterAd';
import InsertHeaderAd from './InsertHeaderAd';
import InsertSidebarAd from './InsertSidebarAd';
app.initializers.add('nagusi/ads', () => {
  const enabledSlots = JSON.parse(app.data['nagusi-ext-ads.enabled-ad-locations']);
  if (enabledSlots.includes('header')) {
    InsertHeaderAd();
  }
  if (enabledSlots.includes('discussion_header')) {
    InsertDiscussionPageHeaderAd();
  }
  if (enabledSlots.includes('footer')) {
    InsertFooterAd();
  }
  if (enabledSlots.includes('between_posts')) {
    InsertBetweenPostsAds();
  }
  if (enabledSlots.includes('between_discussions')) {
    InsertBetweenDiscussionsAds();
  }
  if (enabledSlots.includes('sidebar')) {
    InsertSidebarAd();
  }
  if (enabledSlots.includes('discussion_sidebar')) {
    InsertDiscussionSidebarAd();
  }
});